import { useCallback, useState } from "react";
import {
  openConnectDashboard,
  startConnectOnboarding,
} from "../lib/stripe.js";
import { useCoachBilling } from "../context/CoachBillingContext.jsx";

export function useStripeConnect() {
  const {
    connect,
    connectLoading,
    connectError,
    refetchConnect,
  } = useCoachBilling();
  const [actionBusy, setActionBusy] = useState(false);
  const [actionError, setActionError] = useState(null);

  const refetch = useCallback(() => refetchConnect(), [refetchConnect]);

  async function beginOnboarding() {
    setActionBusy(true);
    setActionError(null);
    try {
      const { url } = await startConnectOnboarding();
      if (url) window.location.assign(url);
    } catch (e) {
      setActionError(e?.message ?? String(e));
    } finally {
      setActionBusy(false);
    }
  }

  async function openDashboard() {
    setActionBusy(true);
    setActionError(null);
    try {
      const { url } = await openConnectDashboard();
      if (url) window.open(url, "_blank", "noopener,noreferrer");
    } catch (e) {
      setActionError(e?.message ?? String(e));
    } finally {
      setActionBusy(false);
    }
  }

  return {
    connect,
    isLoading: connectLoading,
    error: actionError ?? connectError,
    actionBusy,
    refetch,
    beginOnboarding,
    openDashboard,
  };
}
